import { Box, Dialog, DialogProps, Grid } from "@material-ui/core";
import { Formik } from "formik";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import {
    Title,
    yupMaxLengthField,
    yupMinLengthField,
    yupMinValueField,
    yupRequiredField,
} from "ui/componentes";
import { ProtestForm } from "ui/views/Protests/ProtestForm";
import { ProtestDefaultValues } from "ui/views/Protests/ProtestView";
import { sendProtest } from "ui/views/Protests/sendProtestFunction";
import * as Yup from "yup";
import { useCurrentSeason, useThemeBreakpoints } from "api";

const ProtestFormValidation = Yup.object().shape({
    seasonId: Yup.string().required(yupRequiredField),
    championshipId: Yup.string().required(yupRequiredField),
    roundId: Yup.string().required(yupRequiredField),
    raceControlId: Yup.string().required(yupRequiredField),
    lap: Yup.number().required(yupRequiredField).min(0, yupMinValueField),
    infractionId: Yup.string().required(yupRequiredField),
    complaint: Yup.string()
        .required(yupRequiredField)
        .min(50, yupMinLengthField)
        .max(300, yupMaxLengthField),
    protestedDriverId: Yup.string().required(yupRequiredField),
});

const ProtestFormDialog: React.FC<DialogProps> = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const { isDownXs } = useThemeBreakpoints();
    const currentSeason = useCurrentSeason() || {};
    const [initialValues, setInitialValues] = useState({
        ...ProtestDefaultValues,
    });

    useEffect(() => {
        if (!initialValues.seasonId) {
            setInitialValues((old) => ({
                ...old,
                seasonId: currentSeason.id,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSeason.id, initialValues.seasonId]);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={ProtestFormValidation}
            onSubmit={(protest, { setSubmitting, resetForm }) => {
                sendProtest(
                    protest,
                    setSubmitting,
                    resetForm,
                    enqueueSnackbar
                ).then(() => {
                    if (props.onClose) {
                        props.onClose({}, "escapeKeyDown");
                    }
                });
            }}
        >
            {() => {
                return (
                    <Dialog
                        {...props}
                        fullScreen={isDownXs}
                        disableBackdropClick
                        disableEscapeKeyDown
                        maxWidth="md"
                        fullWidth
                    >
                        <Box p={3}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Title text="Abertura de protestos" />
                                </Grid>
                                <Grid item xs={12} style={{ marginTop: 5 }}>
                                    <ProtestForm onClose={props.onClose} />
                                </Grid>
                            </Grid>
                        </Box>
                    </Dialog>
                );
            }}
        </Formik>
    );
};

export { ProtestFormDialog };
